import { HardHat } from 'lucide-react';
import { useAuth } from './lib/AuthContext';
import { gcName } from './lib/format';

interface PlaceholderPageProps {
  notFound?: boolean;
}

/**
 * Phase 0 placeholder. Confirms Tailwind, design tokens, Inter, lucide-react,
 * and React Router are all wired up. Real screens land in Phase 2.
 */
export function PlaceholderPage({ notFound = false }: PlaceholderPageProps) {
  const { me } = useAuth();
  return (
    <main className="min-h-screen bg-page text-fg">
      <div className="mx-auto flex max-w-2xl flex-col gap-6 px-6 py-24">
        <div className="flex items-center gap-3 text-bronze">
          <HardHat size={20} strokeWidth={1.5} />
          <span className="text-sm font-medium tracking-wide uppercase">Coffman Excavation</span>
        </div>
        <h1 className="text-3xl font-medium text-fg">
          {notFound ? 'Page not found' : 'T&M billing portal'}
        </h1>
        <p className="text-fg-secondary">
          {notFound
            ? 'The page you requested does not exist.'
            : 'Phase 0 scaffolding live. Real screens land in Phase 2 — see docs/Build_Specification.md §6.'}
        </p>
        <div className="rounded border border-line bg-surface p-4 text-sm text-fg-muted">
          Project {me?.project.project_number ?? '25132'} · {gcName(me)} ·{' '}
          {me?.project.name ?? 'the project'}
        </div>
      </div>
    </main>
  );
}
